import React from 'react';
import { motion } from 'framer-motion';

const AIFrameworksDemo = () => {
  return (
    <div className="relative w-full h-full p-4 flex items-center justify-center overflow-hidden">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full h-full max-w-4xl"
      >
        <img 
          src="/assets/demos/ai-frameworks.svg"
          alt="AI Frameworks Integration Visualization"
          className="w-full h-full object-contain"
        />
      </motion.div>
    </div>
  );
};

export default AIFrameworksDemo;